import { Injectable } from '@angular/core';
import {
  FieldsetBaseType,
  InputBaseLabelTranslationType,
  InputBaseType,
} from '../types';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {
  buildInputProps(inputProps: InputBaseType): InputBaseType {
    return {
      className: inputProps.className ?? '',
      disabled: !!inputProps.disabled,
      key: inputProps.key ?? '',
      labelTranslation: this.buildFieldLabels(inputProps),
      maxLength: inputProps.maxLength,
      minLength: inputProps.minLength,
      readonly: !!inputProps.readonly,
      placeholder: inputProps.placeholder ?? '',
      syncValidators: inputProps.syncValidators,
      selectOptions: inputProps.selectOptions,
      type: inputProps.type ?? 'text',
      prefilledValue: inputProps.prefilledValue,
      requiredOnSubmit: inputProps.requiredOnSubmit ?? false,
    };
  }

  buildFieldsetProps(fieldsetProps: FieldsetBaseType): FieldsetBaseType {
    return {
      title: fieldsetProps.title ?? '',
      className: fieldsetProps.className ?? '',
      disabled: !!fieldsetProps.disabled,
      elements: fieldsetProps.elements
        .filter((el) => !!el.input)
        .map((element) => ({
          className: element.className ?? '',
          input: element.input,
        })),
    };
  }

  buildFieldLabels(inputProps: InputBaseType): InputBaseLabelTranslationType {
    if (inputProps.labelTranslation) {
      return inputProps.labelTranslation;
    } else {
      return {
        // @ts-ignore
        label: inputProps.label,
        emptyErrorLabel: inputProps.label + '_empty',
        invalidPatternErrorLabel: inputProps.label + '_invalid_pattern',
      };
    }
  }
}
